module.exports = __webpack_public_path__ + "static/media/add-white-icon.869f7740.svg";